import React from 'react';
import styled from 'styled-components';
import { Color, TrevorComponent } from '../../types';
import { applyColor } from '../../utils';
import { NAME_TO_ICON } from './config';

const SIZE_MAP = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
} as const;

type IconSize = 'sm' | 'md' | 'lg' | 'xl';

const sizeToPX = (size: IconSize | number): number =>
  SIZE_MAP[size as IconSize] ?? size;

export type TrevorIconName = keyof typeof NAME_TO_ICON;

export type TrevorIconProps = {
  name: TrevorIconName;
  onClick?: F<React.MouseEvent>;
} & ({ size?: IconSize | number } | { width: number; height: number });

const Icon: TrevorComponent<TrevorIconProps> = ({ name, ...rest }) => {
  const [width, height] =
    'width' in rest
      ? [rest.width, rest.height]
      : [sizeToPX(rest.size ?? 'sm'), sizeToPX(rest.size ?? 'sm')];

  const Component = NAME_TO_ICON[name];

  return <Component width={width} height={height} {...rest} />;
};

export const TrevorIcon = styled(Icon)<{ $color?: Color }>`
  ${applyColor}
`;
